import { FC, MouseEvent, TouchEvent, useRef } from 'react';

import { useMap } from '@mopla/business-logic';
import { ILatLng } from '@mopla/data-models';

import { Map, MapWrapper } from './RouteMap.styles';

interface IRouteMapProps {
	showRoute: boolean;
	waypoints: ILatLng[];
}

export const RouteMap: FC<IRouteMapProps> = (props) => {
	const { showRoute, waypoints } = props;
	const mapRef = useRef<null | HTMLDivElement>(null);

	useMap({
		waypoints,
		ref: mapRef.current,
		deps: [],
		showRoute,
	});

	return (
		<MapWrapper
			data-testid="route-card-map"
			onTouchStart={(e: TouchEvent<HTMLDivElement>) => e.stopPropagation()}
			onTouchMove={(e: TouchEvent<HTMLDivElement>) => e.stopPropagation()}
			onTouchEnd={(e: TouchEvent<HTMLDivElement>) => e.stopPropagation()}
			onMouseDown={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()}
			onMouseMoveCapture={(e: MouseEvent<HTMLDivElement>) =>
				e.stopPropagation()
			}
			onMouseUp={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()}
			onMouseLeave={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()}
		>
			<Map ref={mapRef} />
		</MapWrapper>
	);
};
